export const updateSEO = (seo, { href },  title) => {
  seo.canonical = href
  seo.title = title//`${title} - ${seo.title}`
  seo.opengraphTitle = title
  //seo.opengraphTitle = `${title} - ${seo.opengraphTitle}`
  return seo
}

export const gradiMeta = ({seo, location: { pathname,  origin, href }, title, currentBrand}) => {
  let titleMeta = []
  if (title) {
    const builtTitle = `${title} - ${currentBrand.brandStyle}` 
    seo.title = builtTitle
    seo.opengraphTitle = builtTitle
  }
return [
    {
      name: 'og:url',
      content: href || seo?.opengraphUrl
    },
    ...titleMeta
  ]


}

